import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, map, Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

@Injectable({
    providedIn: 'root',
})
export class DocumentService {
    private apiServiceUrl = environment.apiUrl;
    deleteDocRecord = new BehaviorSubject<any>(null);

    constructor(private http: HttpClient) {}

    public getAllDocRequest(): Observable<any> {
        const url = `${this.apiServiceUrl}/aipo/document/api/requestList`
        return this.http.get(url).pipe(
            map((response: any) => {
                return response
            })
        )
    }
    public submitDocument(
        clientName: string,
        file: File,
        transcript: string | null,
        domain: string,
        submitterName: string,
        documentType: string
    ): Observable<any> {
        const formData: FormData = new FormData()
        formData.append('clientName', clientName)
        formData.append('file', file, file.name)
        if (transcript) {
            formData.append('transcript', transcript)
        }
        formData.append('domain', domain)
        formData.append('submitterName', submitterName)
        formData.append('documentType', documentType)

        const url = `${this.apiServiceUrl}/aipo/document/api/submit`
        return this.http.post(url, formData)
    }
    public getDocumentResponse(requestId: string): Observable<any> {
      const url = `${this.apiServiceUrl}/aipo/document/api/document-response?requestId=${requestId}`;
      return this.http.get(url);
    }

    public deleteRecord(requestId:number){
        const apiUrl=`${this.apiServiceUrl}/aipo/document/api/delete?requestId=${requestId}`;
        return this.http.delete(apiUrl);   
    }
}
